import { api } from "../App";
import { SET_TV_PROGRAM_SCHEDULE_LIST, SET_TV_PROGRAM_SCHEDULE_WEEKS_LIST, SET_TV_PROGRAM_SCHEDULE_LOADING } from "./types";

export const getTvProgramSchedule = ({ begdate, enddate, ...date }) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_LOADING, payload: true });
    const urlParams = new URLSearchParams({ begdate, enddate }).toString();

    const { data } = await api.get(`/tv_program_schedule?${urlParams}`);
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_LIST, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_LOADING, payload: false });
  }
}
export const getTvProgramScheduleWeeks = (year) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_LOADING, payload: true });
    const { data } = await api.get(`/weeks/${year}`);
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_WEEKS_LIST, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_LOADING, payload: false });
  }
}

export const createTvProgramSchedule = (payload, filters, filename, subfolder) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_LOADING, payload: true });
    const { data } = await api.post('/tv_program_schedule', payload);
    if (subfolder !== null) await dispatch(createTvProgramScheduleFile(subfolder, data.id, filename, filters))
    await dispatch(getTvProgramSchedule(filters))
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_LOADING, payload: false });
    return success
  }
}


export const updateTvProgramSchedule = (id, data, filters) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_LOADING, payload: true });
    await api.put(`/tv_program_schedule/${id}`, data);
    await dispatch(getTvProgramSchedule(filters))
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_LOADING, payload: false });
    return success
  }
}

export const deleteTvProgramSchedule = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_LOADING, payload: true });
    await api.delete(`/tv_program_schedule/${id}`);
    await dispatch(getTvProgramSchedule())
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_LOADING, payload: false });
  }
}



export const createTvProgramScheduleFile = (data, id, subfolder, filters) => async (dispatch, getState) => {
  const fd = new FormData();
  fd.append("file", data);
  let success
  try {
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_LOADING, payload: true });
    await api.post(`/tv_program_schedule/file/${subfolder}/${id}`, fd);
    await dispatch(getTvProgramSchedule(filters))
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_TV_PROGRAM_SCHEDULE_LOADING, payload: false });
    return success
  }
}